
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[id]",
      function () {
        return require("private-next-pages/info/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[id]"])
      });
    }
  